module.exports = __webpack_public_path__ + "static/media/icon2.8b48af8b.png";